import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import ReactGA from 'react-ga';

import { tabResultState } from '../../../modules/tabResult';

const RelatedSearchComponent = styled.div`
  margin-top: 24px;
  width: 100%;
  max-height: 105px;
  border-radius: 8px;
  border: solid 1px #e1e6f0;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 12px;
  padding-bottom: 12px;
`;

const RelatedSearchTitle = styled.div`
  font-size: 16px;
  color: #555555;
  font-weight: 500;
`;

const RelatedSearchLinkBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: 44px;
  margin-top: 6px;
  overflow: hidden;
`;

const LinkItem = styled.div`
  font-size: 14px;
  color: #1a0dab;
  font-weight: normal;
  margin-right: 20px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

interface RelatedSearchProps extends RouteComponentProps {
  relatedWord: tabResultState['relatedWord'];
}

class RelatedSearch extends React.PureComponent<RelatedSearchProps, any> {
  makeLink = (): ReactNode[] | null => {
    const { relatedWord } = this.props;
    const result: ReactNode[] | null = [];
    if (relatedWord.length > 0) {
      relatedWord.forEach((element) => {
        result.push(
          <LinkItem
            onClick={() => {
              this.onClickItem(element);
            }}
          >
            {element}
          </LinkItem>
        );
      });
    }

    return result;
  };

  onClickItem = async (element: string) => {
    const { history } = this.props;
    await ReactGA.ga('send', 'event', `click_search_result_연관검색어`);

    history.push(`/search/result?q=${element}`);
    window.location.reload(true);
  };

  render() {
    return (
      <RelatedSearchComponent>
        <RelatedSearchTitle>연관 검색어</RelatedSearchTitle>
        <RelatedSearchLinkBox>{this.makeLink()}</RelatedSearchLinkBox>
      </RelatedSearchComponent>
    );
  }
}

export default withRouter(RelatedSearch);
